import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import tagsView from './modules/tagsView'

import user from './modules/user'
import setting from './modules/setting'
import labels from "@/store/modules/labels"
import im from "@/store/modules/im" // 新增的IM模块
Vue.use(Vuex)

const store = new Vuex.Store({
  // 引用模块
  modules: {
    app,
    user,
    setting,
    tagsView,
    labels,
    im // 添加IM模块
  },
  state: {
  },
  // 操作异步操作mutations
  actions: {
    // 清除缓存
    clear({ commit }) {
      store.dispatch('setting/clear')
      store.dispatch('user/clear')
      store.dispatch('im/clear') // 添加IM清除方法
    }
  },
  mutations: {
    mapChangeAddress(state, mapChangeAddress) {
      state.mapChangeAddress = mapChangeAddress
    },
    requestUrl(state, requestUrl) {
      state.requestUrl = requestUrl
    }
  },
  getters: {
    url: state => state.setting.url,

    token: state => state.user.token,
    avatar: state => state.user.avatar,
    name: state => state.user.userName,
    menus: state => state.user.menus,
    menu: state => state.user.menu,

    sidebar: state => state.app.sidebar,
    device: state => state.app.device,
    // 新增IM相关的getters
    timInstance: state => state.im.timInstance,
    conversations: state => state.im.conversations,
    currentConversation: state => state.im.currentConversation,
    currentMessages: state => state.im.currentMessages
  }
})

export default store
